var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('left_panel_performance_table',{attrs:{"performance":this.performance,"title":"Today's performance"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }